export function getDomainFromHost() {
  if (typeof window === "undefined") return "us";

  const host = window.location.hostname;

  if (host.includes(".com.br")) return "com.br";
  if (host.includes(".pt")) return "pt";
  if (host.includes(".co")) return "co";
  if (host.includes(".us")) return "us";

  return "us";
}
